// extracted by mini-css-extract-plugin
export default {"ModeSwitch":"ModeSwitch_ModeSwitch__m5J7O"};